<template> 
    <div class="container" 
        element-loading-background = "rgba(255, 255,255,0.7)"
        :element-loading-text = "loadingText"
        v-loading="loading"  style="width:95%;">

        <el-form ref="form" :model="form" label-width="180px">
            
            <el-form-item   label="学校切换">
                <el-select v-model="form.deptId" placeholder="请选择学校" @change="getData">
                    <el-option
                        v-for="item in depts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--<el-form-item label="启用推送："><el-checkbox v-model="form.pushSwitch"></el-checkbox></el-form-item>-->
            <el-form-item label="平台接管好评是否提醒家长">
                <el-switch  v-model="form.dp1NoticeParentSign"></el-switch>
            </el-form-item>
            <el-form-item label="">
                <el-radio-group  v-model="form.dp1NoticeParentTimeType">
                    <el-radio :label="0" border :disabled="!form.dp1NoticeParentSign">实时推送给家长</el-radio><br>
                    <el-radio :label="1" border :disabled="!form.dp1NoticeParentSign">每天推送1次晚上6点</el-radio><br>
                    <el-radio :label="2" border :disabled="!form.dp1NoticeParentSign">每天推送2次中午12点和晚上6点</el-radio><br>
                    <el-radio :label="3" border :disabled="!form.dp1NoticeParentSign">不推送家长</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="平台接管差评是否提醒家长">
                <el-switch  v-model="form.dp2NoticeParentSign"></el-switch>
            </el-form-item>
            <el-form-item label="">
                <el-radio-group  v-model="form.dp2NoticeParentTimeType">
                    <el-radio :label="0" border :disabled="!form.dp2NoticeParentSign">实时推送给家长</el-radio><br>
                    <el-radio :label="1" border :disabled="!form.dp2NoticeParentSign">每天推送1次晚上6点</el-radio><br>
                    <el-radio :label="2" border :disabled="!form.dp2NoticeParentSign">每天推送2次中午12点和晚上6点</el-radio><br>
                    <el-radio :label="3" border :disabled="!form.dp2NoticeParentSign">不推送家长</el-radio>
                </el-radio-group>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer" style="text-align:left;">
            <el-button type="danger"  @click="clear()">重置</el-button>
            <el-button type="primary"  @click="savePushSet()">确定</el-button>
        </span>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 

    export default {
        name:"",
        data(){
            return{
                loading:false,
                loadingText:"",
                form:{
                    deptId:"",
                    // pushSwitch: false,
                    dp1NoticeParentSign:false,
                    dp1NoticeParentTimeType:0,
                    dp2NoticeParentSign:false,
                    dp2NoticeParentTimeType:0
                },
                depts:[],
            }
        },
        components: {
        },
        created:function () {
            // this.form.pushSwitch=false
            this.form.dp1NoticeParentSign=false
            this.form.dp1NoticeParentTimeType=0
            this.form.dp2NoticeParentSign=false
            this.form.dp2NoticeParentTimeType=0
            
            // 初始学校数据
            this.getDeptData()
        },
        methods:{
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl
                let data = {parentId:"0"}
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id
                        }
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                })
            },
            getData(){
                let url  = this.pushSetListUrl
                let data = {
                    deptId:this.form.deptId
                };
                // console.log(JSON.stringify(data));
                // return;
                this.apiPost(url,data).then((res) => {
                    console.log('推送设置',res)
                    if(res.status==200){
                         let dataArr = res.data
                         if(dataArr.length > 1){
                            for(let i=0;i<dataArr.length;i++){
                                // if(dataArr[i].paramKey == "pushSwitch"){
                                //     this.form.pushSwitch = dataArr[i].paramInt == 1?true:false;
                                // }else 
                                if(dataArr[i].paramKey == "dp1NoticeParentSign"){
                                    this.form.dp1NoticeParentSign = dataArr[i].paramInt == 1?true:false;
                                }else if(dataArr[i].paramKey == "dp1NoticeParentTimeType"){
                                    this.form.dp1NoticeParentTimeType = dataArr[i].paramInt; 
                                }else if(dataArr[i].paramKey == "dp2NoticeParentSign"){
                                    this.form.dp2NoticeParentSign = dataArr[i].paramInt == 1?true:false;
                                }else if(dataArr[i].paramKey == "dp2NoticeParentTimeType"){
                                    this.form.dp2NoticeParentTimeType = dataArr[i].paramInt;
                                }
                            }
                        }else{
                            // this.form.pushSwitch=false
                            this.form.dp1NoticeParentSign=false
                            this.form.dp1NoticeParentTimeType=0
                            this.form.dp2NoticeParentSign=false
                            this.form.dp2NoticeParentTimeType=0
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            savePushSet(){
                // 构造数据
                let formData = new Array()

                // 启用推送
                // let formObject = {}
                // formObject.paramKey = "pushSwitch"
                // formObject.paramInt = this.form.pushSwitch?1:0
                // formData.push(formObject)

                // 好评是否提醒家长
                let formObject = {};
                formObject.paramKey = "dp1NoticeParentSign"
                formObject.paramInt = this.form.dp1NoticeParentSign?1:0
                formData.push(formObject)
                
                // 好评是否提醒家长模式
                if(this.form.dp1NoticeParentSign){
                    formObject = {}
                    formObject.paramKey = "dp1NoticeParentTimeType"
                    formObject.paramInt = this.form.dp1NoticeParentTimeType
                    formData.push(formObject)
                }

                // 差评是否提醒家长
                formObject = {}
                formObject.paramKey = "dp2NoticeParentSign"
                formObject.paramInt = this.form.dp2NoticeParentSign?1:0
                formData.push(formObject)
                
                // 好评是否提醒家长模式
                if(this.form.dp2NoticeParentSign){
                    formObject = {}
                    formObject.paramKey = "dp2NoticeParentTimeType"
                    formObject.paramInt = this.form.dp2NoticeParentTimeType
                    formData.push(formObject)
                }

                let data = {
                    deptId:this.form.deptId,
                    data: JSON.stringify(formData)
                }

                this.loading=true
                this.loadingText="数据加载中..."

                let url  = this.pushSetSaveUrl
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1)
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                }, (err) => {
                    console.log(err)
                    this.loading=false
                });
            },
            clear(){
                let data = {
                    deptId:this.form.deptId
                }

                this.loading=true
                this.loadingText="数据删除中..."

                let url  = this.pushSetRemoveUrl
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1)
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                }, (err) => {
                    console.log(err)
                    this.loading=false
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/task/PushSet.vue